import React from 'react'
import StudentProfileCard from '../../../dashboard/StudentProfile/StudentProfile'

const StudentProfile = () => {
  return (
    <div>
        <StudentProfileCard/>
    </div>
  )
}

export default StudentProfile